export const pdfTableColumnsWidth = (isGroupSessionEvent) => {
  return {
    slot: '7%',
    nameWidth: isGroupSessionEvent ? '25%' : '17%',
    status: '18%',
    confirmation: '18%',
    revenue: '10%'
  };
};
